export default __webpack_public_path__ + "static/media/wolf.d49d5c1b.svg";